import React, { useState, useEffect } from 'react';
import styles from './SearchLoader.module.scss';

interface SearchLoaderProps {
  searchTerm?: string;
}

export default function SearchLoader({ searchTerm }: SearchLoaderProps) {
  const [messageIndex, setMessageIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  
  const messages = [
    'Analyse de votre recherche...',
    'Traitement des données...',
    'Filtrage des résultats...',
    'Vérification des correspondances...',
    'Finalisation de la recherche...'
  ];

  // Réinitialiser le message quand le terme de recherche change
  useEffect(() => {
    setMessageIndex(0);
    setIsTransitioning(false);
  }, [searchTerm]);

  // Changer de message après un délai pour créer une progression
  useEffect(() => {
    if (messageIndex < messages.length - 1) {
      const timer = setTimeout(() => {
        setIsTransitioning(true);
        // Attendre la fin de la transition de sortie avant de changer le message
        setTimeout(() => {
          setMessageIndex(prev => prev + 1);
          // Petit délai avant de réafficher pour une transition plus fluide
          setTimeout(() => {
            setIsTransitioning(false);
          }, 50);
        }, 300); // Durée de la transition de sortie
      }, 2500); // Change de message toutes les 2.5 secondes pour laisser le temps de lire
      
      return () => clearTimeout(timer);
    }
  }, [messageIndex, messages.length]);

  return (
    <div className={styles.searchLoader}>
      <div className={styles.loaderContainer}>
        <div className={styles.loaderSpinner}>
          <div className={styles.spinnerRing}></div>
          <div className={styles.spinnerRing}></div>
          <div className={styles.spinnerRing}></div>
        </div>
        
        <div className={styles.loaderContent}>
          <h3 className={styles.loaderTitle}>Recherche en cours</h3>
          <div className={styles.messageWrapper}>
            <p className={`${styles.loaderMessage} ${isTransitioning ? styles.fadeOut : styles.fadeIn}`}>
              {messages[messageIndex]}
              {searchTerm && ` pour "${searchTerm}"`}
            </p>
          </div>
          <div className={styles.loaderProgress}>
            <div className={styles.progressBar}>
              <div className={styles.progressFill}></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

